import httpClient from '@/utilities/service/httpClient'
import AbstractApi from '@/api/abstracts/AbstractApi'
import { MondayProjectStatusResponseType } from '@/api/types/response/MondayApiType'

/**
 * @property string apiEnd /api/adjustment/monday
 */
export default class MondayApi extends AbstractApi {
  customers(): Promise<unknown> {
    return httpClient.post(`${this.apiEnd}/customers`)
  }

  projectStatus(): Promise<MondayProjectStatusResponseType> {
    return httpClient.post(`${this.apiEnd}/update-project-status`)
  }

  updateUsers(): Promise<unknown> {
    return httpClient.post(`${this.apiEnd}/update-users`)
  }
}
